import { useShopPlanInfo } from 'hooks/useShopPlanInfoStatus';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { shopifyReviewDialogDisplayed } from 'redux/slices/shopify-review-dialog/shopify-review-dialog.reducer';
import { getShopifyReviewDialogIsDisplayed } from 'redux/slices/shopify-review-dialog/shopify-review-dialog.selector';

export const useShopifyReviewModal = () => {
    const dispatch = useAppDispatch();
    const isDisplayed = useAppSelector(getShopifyReviewDialogIsDisplayed);
    const { isPartnerDevelopmentUser, isLoading } = useShopPlanInfo();

    // Memoized, so callers can run it from an effect that only re-runs when one of these guards changes
    const openReviewModal = useCallback(async () => {
        if (isDisplayed || isPartnerDevelopmentUser || isLoading) return;
        try {
            await shopify?.reviews?.request();
        } catch (error) {
            //comment for not empty commit
        }
        dispatch(shopifyReviewDialogDisplayed());
    }, [isDisplayed, isPartnerDevelopmentUser, isLoading, dispatch]);

    return openReviewModal;
};
